import React from 'react';
import { Modal, Button } from 'antd';


class PassportModal extends React.Component {
  state = { visible: false }

  showModal = () => {
    this.setState({
      visible: true,
    });
  }
  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  }
  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  }
  render() {
    return (
      <div>
        <Button type="primary" size="small" onClick={this.showModal}>Example Here</Button>
        <Modal
          title="Example"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={[]}
        >
        {this.props.children}
        <p>Image source: Google and US State Department</p> 
        </Modal>
      </div>
    );
  }
}

export default PassportModal;


// WEBPACK FOOTER //
// ./portal-components/Portal/Travel/PassportModal.jsx